import type {Route} from '../lib/router/routes.js';

export const routes: Route[] = [
  {
    path: '/example',
    import: () => import('../pages/example/index.js'),
  },
];
